import getQuickAddViewState from '../selectors/getQuickAddViewState';
import { mutator } from 'satcheljs';
import { setFolderId, setIsFocused, setIsShown, setSubject } from '../actions/quickAddActions';

export const setSubjectMutator = mutator(setSubject, actionMessage => {
    getQuickAddViewState().subject = actionMessage.subject;
});

export const setFolderIdMutator = mutator(setFolderId, actionMessage => {
    let folderId: string = actionMessage.folderId;
    getQuickAddViewState().folderId = folderId;
});

export const setIsShownMutator = mutator(setIsShown, actionMessage => {
    getQuickAddViewState().isShown = actionMessage.isShown;
});

export const setIsFocusedMutator = mutator(setIsFocused, actionMessage => {
    getQuickAddViewState().isFocused = actionMessage.isFocused;
});
